import React from 'react';

import { useToggle } from '@hooks/useToggle';

const CheckboxForSettings = props => {

    const {
        value,
        settingName,
        handleInputChange
    } = props;

    const [ isChecked, toggleChecking ] = useToggle(value);

    const handle = e => {
        toggleChecking();
        handleInputChange(e);
    };

    return (
        <span
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                lineHeight: 1,
            }}
        >
            <input
                type="checkbox"
                checked={ isChecked }
                name={ settingName }
                onChange={ e => handle(e) }
                style={{
                    margin: 0,
                    verticalAlign: 'middle',
                }}
            />
        </span>
    );
};

export default CheckboxForSettings;